/**
 * @arg date - must be Date object
 * @return object { day: 'DD.MM', time: 'HH:MM UTC' }
 */
export const formatDateTime = (date: Date) => {
  const formattedDate = { day: '', time: '' };

  const day = date.getUTCDate() < 10 ? `0${date.getUTCDate()}` : `${date.getUTCDate()}`;
  const month =
    date.getUTCMonth() + 1 < 10 ? `0${date.getUTCMonth() + 1}` : `${date.getUTCMonth() + 1}`;
  const hours = date.getUTCHours() < 10 ? `0${date.getUTCHours()}` : `${date.getUTCHours()}`;
  const minutes =
    date.getUTCMinutes() < 10 ? `0${date.getUTCMinutes()}` : `${date.getUTCMinutes()}`;

  formattedDate.day = `${day}.${month}`;
  formattedDate.time = `${hours}:${minutes} UTC`;

  return formattedDate;
};

/**
 * @arg date - must be Date object
 * @return date string 'DD.MM.YYYY'
 */
export const formatDate = (date: Date) => {
  const day = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
  const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

/**
 * @arg dateTime - must be Date object and string
 * @return 'Oct 10 (23:59 UTC)'
 */
export const formatDateAndTime = (dateTime: string | Date) => {
  const date = new Date(dateTime);

  const timeFormatter = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: 'UTC',
    hour12: false,
  });
  const monthDayFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });

  const time = timeFormatter.format(date);
  const formattedMonthDay = monthDayFormatter.format(date);

  return `${formattedMonthDay} (${time} UTC)`;
};

export function getNextDayOfTheWeek(
  dayNumber?: number | null,
  excludeToday = true,
  refDate = new Date()
) {
  if (dayNumber === undefined || dayNumber === null) {
    return null;
  }
  refDate.setHours(0, 0, 0, 0);
  refDate.setDate(
    refDate.getDate() + +!!excludeToday + ((dayNumber + 7 - refDate.getDay() - +!!excludeToday) % 7)
  );
  return refDate;
}
